export default __webpack_public_path__ + "static/media/char_head_prem_014.56cd632d.png";